module.exports = __webpack_public_path__ + "img/location_icon.6f0f232a.png";